import styled from 'styled-components';
export const StyledTextInput = styled.div`
  border: solid 2px ${({ theme, $focused }) => $focused ? 'white' : theme.inputBorder};
  width: 100%;
  background: ${({ theme }) => theme.buttonDark};

  input {
    padding: 8px 16px;
    background: transparent;
    width: 100%;
    resize: none;
    border: none;
    outline: none;
    caret-color: white;
    font-family: "NeueMachina";
    font-size: 1rem;
    line-height: 1.4rem;
    color: white;
  }
`;
